<template>
  <div>
    <h1 id="jump-to-header">{{heading || generated_heading + " Update"}}</h1>
    <product-item-update :id="id" @gotAttrs="assignAttrs"/>
  </div>
</template>

<script>
import ProductItemUpdate from './ProductItemUpdate.vue'

export default {
  components: {
    ProductItemUpdate
  },
  props: {
    id: String,
    heading: {
      Type: String
    }
  },
  data () {
    return {
      generated_heading: undefined,
      filtering: {
        product_model_ids: this.id
      },
      ams_template: {
        type: 'product-listings',
        description: undefined,
        attributes: {
          'product-model-id': this.id,
          'price-cents': 0
        }
      },
      attrs: {},
    }
  },
  methods: {
    assignAttrs(attrs, description) {
      this.generated_heading = "Serial / Copy #" + description
      this.attrs = Object.assign( {}, attrs)
      this.ams_template.description = description + ' (copy) ' + attrs['serial-number']
    }
  },
  mounted() {
    const element = document.getElementById("jump-to-header")
    element.scrollIntoView({ behavior: "smooth", block: "end", inline: "nearest" })
  }
}
</script>